var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c-mapbox-templating__attribution" }, [
      _c(
        "a",
        {
          attrs: {
            href: "https://www.mapbox.com/about/maps/",
            target: "_system",
          },
        },
        [_vm._v("© Mapbox © OpenStreetMap")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "mapbox-improve-map",
          attrs: {
            href: "https://www.mapbox.com/map-feedback/",
            target: "_system",
          },
        },
        [_vm._v("Improve this map")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./Assets/Scripts/Components/Mapbox/attribution/attribution.vue?vue&type=template&id=cd8a3dba&
// module id = 403
// module chunks = 1